import { Users, Filter, Crown, Award, ShieldCheck, Sparkles, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import AdminSectionLayout from "../components/admin/AdminSectionLayout";
import AdminTile from "../components/admin/AdminTile";
import TestLearnerResetCard from "../components/admin/TestLearnerResetCard";

/**
 * AdminUsers — Feb 6, 2026 (preview-fix Feb 6, 2026 PM).
 *
 * Every visible tile opens its OWN dedicated page. The "all users
 * directory" + anything else not yet migrated lives in the legacy
 * admin panel, surfaced as one explicit link at the bottom — not as
 * multiple tiles that secretly route to the same place.
 */
export default function AdminUsers() {
  return (
    <AdminSectionLayout
      title="Users"
      subtitle="Acquisition · access · approvals"
      icon={Users}
      accent="blue"
      testid="admin-users-page"
    >
      <AdminTile
        to="/admin/funnels"
        icon={Filter}
        label="Acquisition funnels"
        desc="Where new users come from and where they drop off"
        accent="indigo"
        testid="admin-users-tile-funnels"
      />
      <AdminTile
        to="/admin/funnel"
        icon={Sparkles}
        label="Assessment funnel detail"
        desc="Learner assessment journey · attempts · conversions"
        accent="violet"
        testid="admin-users-tile-assessment-funnel"
      />
      <AdminTile
        to="/admin/founder-mode"
        icon={Crown}
        label="Founder mode"
        desc="Switch role to view as learner / ADI / PDI"
        accent="amber"
        testid="admin-users-tile-founder-mode"
      />
      <AdminTile
        to="/admin/beta"
        icon={ShieldCheck}
        label="Beta access"
        desc="Who's in the closed beta · invite codes"
        accent="emerald"
        testid="admin-users-tile-beta"
      />
      <AdminTile
        to="/admin/badge-queue"
        icon={Award}
        label="Badge approvals"
        desc="Trust-stack badge queue awaiting review"
        accent="rose"
        testid="admin-users-tile-badges"
      />

      <TestLearnerResetCard />

      <Link
        to="/admin/legacy"
        data-testid="admin-users-legacy-link"
        className="flex items-center gap-2 mt-4 px-4 py-3 rounded-xl text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
      >
        <ExternalLink className="w-3.5 h-3.5" />
        <span>Subscribers directory & full user controls (legacy panel)</span>
      </Link>
    </AdminSectionLayout>
  );
}
